import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import siteMessage from "@insite/client-framework/SiteMessage";

const emailSubscriptionUrl = "api/v2/email/SubscribeToList";

export interface NewsLetterApiParameter extends ApiParameter {
    emailAddress: string;
}

export async function newsLetter(parameter: NewsLetterApiParameter): Promise<ServiceResult<any>> {
    try {
        const updatedEmail = await post<any>(
            `${emailSubscriptionUrl}/${parameter.emailAddress.toString()}`,
            parameter.emailAddress as any,
        );
        return {
            successful: true,
            result: updatedEmail,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 409) {
            return {
                successful: false,
                errorMessage: siteMessage("Email_Subscribe_Conflict",'').toString(),
                statusCode: error.status
            };
        }

        return {
            successful: false,
            errorMessage: siteMessage("Email_Subscribe_Error",'').toString()            
        };
    }
}
